import React from 'react';
import classNames from 'classnames';

import css from './IconSynchronize.module.css';

/**
 * Synchronize icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconSynchronize = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 8C1 8 3.00498 5.26822 4.63384 3.63824C6.26269 2.00827 8.5136 1 11 1C15.9706 1 20 5.02944 20 10C20 14.9706 15.9706 19 11 19C6.89691 19 3.43511 16.2543 2.35177 12.5M1 8V2M1 8H7"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default IconSynchronize;
